var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDispatchedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#50C878",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4947 17.3547H15.7119C15.8611 17.3547 16.0041 17.2954 16.1096 17.1899C16.2151 17.0844 16.2744 16.9414 16.2744 16.7922V9.57813C16.2744 9.42894 16.2151 9.28587 16.1096 9.18038C16.0041 9.07489 15.8611 9.01562 15.7119 9.01562H7.4375C7.28832 9.01562 7.14524 9.07489 7.03975 9.18038C6.93426 9.28587 6.875 9.42894 6.875 9.57813V16.7866C6.875 16.9357 6.93426 17.0788 7.03975 17.1843C7.14524 17.2898 7.28832 17.3491 7.4375 17.3491H8.16875",
    stroke: "#50C878",
    strokeWidth: 0.84375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4691 17.3531H16.3047V11.5313H19.0638C19.1044 11.5312 19.1445 11.54 19.1814 11.557C19.2183 11.574 19.2511 11.5988 19.2775 11.6297L21.0494 13.7531C21.0913 13.8037 21.1142 13.8674 21.1141 13.9331V17.3531H19.9075",
    stroke: "#50C878",
    strokeWidth: 0.84375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37375 18.9844C10.0634 18.9844 10.6225 18.4177 10.6225 17.7188C10.6225 17.0198 10.0634 16.4531 9.37375 16.4531C8.68408 16.4531 8.125 17.0198 8.125 17.7188C8.125 18.4177 8.68408 18.9844 9.37375 18.9844Z",
    stroke: "#50C878",
    strokeWidth: 0.84375
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6628 18.9844C19.3525 18.9844 19.9116 18.4177 19.9116 17.7188C19.9116 17.0198 19.3525 16.4531 18.6628 16.4531C17.9731 16.4531 17.4141 17.0198 17.4141 17.7188C17.4141 18.4177 17.9731 18.9844 18.6628 18.9844Z",
    stroke: "#50C878",
    strokeWidth: 0.84375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDispatchedIcon);
export default __webpack_public_path__ + "static/media/GreenDispatchedIcon.ed9f0588b36fa4996dcd6aaa1aa58e9b.svg";
export { ForwardRef as ReactComponent };